<template lang="pug">
  .component-credit-bonus-configuration
    ModalReveal(@modalOpen="load", ref="bonusModal")
      button.button(slot="trigger", v-if="item !== null" ) Edit
      button.button(slot="trigger", v-else, @click="$emit('addBonus')") Add Credit bonus
      .row
        .column
          label Name
          input(type="text", v-model="item.name" )
          label Amount
          input(type="text", v-model="item.amount")
          label Promo amount
          input(type="text", v-model="item.promo_amount")
          label Max days
          input(type="text", v-model="item.max_days")
          label Description
          Editor(v-model="item.description" )
        .column
          label Configuration
          ArrayEdit(:values="config", :options="fields")
          label Fallbacks
          input(type="text", v-model="item.fallback_rules" )
      template.text-right(v-slot:[slot]="footer")
        button.button.update(@click="update") Save
</template>

<script>
import SelectizeClientType from '../../structure/ui/lists/selectize/SelectizeClientType'
import DeleteConf from './DeleteConf'
import ModalReveal from "../../structure/foundation/ModalReveal.vue";
import Editor from "../../structure/ui/Editor.vue";
import ArrayEdit from "../../structure/ui/ArrayEdit.vue";

export default {
  name: 'CreditBonusConfiguration',
  components: {ArrayEdit, Editor, ModalReveal, DeleteConf, SelectizeClientType},
  data() {
    return {
      config: {},
      slot: "footer",
      fields: [
        {
          "Address": [
            {
              "address_city": "City",
              "address_postal_code": "Postal code",
              "address_country": "Country",
              "address_street": "Street",
              "address_region": "Region"
            }
          ],
          "Client": [
            {
              "email": "Email",
              "fiscal_code": "Fiscal code",
              "plan_id": "Plan",
              "date_account_after": "Subscribed after date",
              "driver_age": "Age range (xx-xx)",
              "document_type_id": "A valid document of given type",
            }
          ],
          "Actions": [
            {
              "action": "book",
            }
          ],
          "Bonus": [
            {
              "max_uses": "Times that a bonus can be activated",
              "max_client_uses": "Times that a client can receive this bonus",
              "only_with": "Only with another bonus slug",
              "not_with": "Not with another bonus slug",
              "max_amount": "Max amount",
              "gateway_reason": "Gateway reason",
              "current_count": "Current count of given bonuses",
            }
          ]
        }
      ]
    }
  },
  mounted() {
    if (this.item.name === null) {
      const cazzo = this.$refs
      this.$refs.bonusModal.openModal()
    }
  },
  created() {
    if (this.item.config !== null) {
      const config = this.item.config.split('|')
      config.forEach(item => {
        const [key, value] = item.split(':');
        this.config[key] = value;
      });
    }


  },
  methods: {
    load() {

    },
    update() {
      if (this.item == null) {
        return
      }
      this.item.config = Object.entries(this.config)
        .map(([key, value]) => `${key}:${value}`)
        .join('|')

      this.$emit('update')
    }
  },
  computed: {
    configuration() {
      let jsonObject = {}
      console.log(this.item)
      if (this.item == null) {
        return {}
      }
      const config = this.item.config.split('|')
      config.forEach(item => {
        const [key, value] = item.split(':');
        jsonObject[key] = value;
      });

      return jsonObject
    }
  },
  props: ['item']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreditBonusConfiguration.vue?8c32a7b4